import { makeStyles } from '@material-ui/core/styles'

export const workoutPlayerStyles = makeStyles(() => ({
  '@global': {
    '.workoutplayer-bg-video-wrap': {
      position: 'fixed',
      inset: 0,
      overflow: 'hidden',
      zIndex: 1000,
      background: '#000',
    },
    // The video/photo fills the top ~2/3 of the screen; the exercise card sits
    // over the bottom third, so it no longer hides the lower half of the video.
    '.workoutplayer-bg-media': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '66vh',
      overflow: 'hidden',
    },
    '.workoutplayer-bg-video-player': {
      position: 'absolute',
      inset: 0,
    },
    '.workoutplayer-bg-video-player > div, .workoutplayer-bg-video-player > video':
      {
        position: 'absolute !important',
        inset: 0,
        width: '100% !important',
        height: '100% !important',
        pointerEvents: 'none',
      },
    '.workoutplayer-bg-photo': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      pointerEvents: 'none',
    },
    '.workoutplayer-no-video': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'rgba(255,255,255,.6)',
    },

    '.hud-card': {
      background: '#ffffff25',
      border: '1px solid rgba(255,255,255,.08)',
      boxShadow: '0 10px 30px rgba(0,0,0,.35)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      borderRadius: 16,
      color: '#fff',
    },

    '.workoutplayer-hud-container': {
      position: 'fixed',
      inset: 0,
      zIndex: 1200,
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      color: 'white',
    },
    '.workoutplayer-hud-header': {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      top: 0,
      left: 0,
      width: '100vw',
      height: '5em',
      padding: 16,
      // Just enough to keep the header buttons legible over a bright video.
      background:
        'linear-gradient(to bottom, rgba(0,0,0,.45) 0%, rgba(0,0,0,0) 100%)',
    },
    '.workoutplayer-hud-header-row': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
    },
    '.workoutplayer-hud-header-actions': {
      display: 'flex',
      flexDirection: 'row',
      gap: 8,
    },
    '.workoutplayer-header-button': {
      background: 'transparent',
      color: '#fff',
      padding: 8,
      border: 'none',
    },
    '.workoutplayer-timer-badge': {
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 14px',
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: 0.5,
    },

    // Dark enough to keep the white text legible now that the video behind it
    // is no longer darkened by an overlay/gradient.
    '.workoutplayer-controls': {
      padding: 16,
      zIndex: 10,
      background: 'rgba(18,18,18,.82)',
    },

    '.workoutplayer-exercise-title': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      marginBottom: 8,
      overflow: 'hidden',
    },

    '.workoutplayer-exercise-title .exercise-name': {
      margin: 0,
      fontWeight: 600,
      fontSize: 20,
      opacity: 0.85,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '65%',
    },

    '.workoutplayer-exercise-title .exercise-counter': {
      fontSize: 14,
      fontWeight: 600,
      fontVariantNumeric: 'tabular-nums',
      padding: '2px 10px',
      borderRadius: 12,
      background: 'rgba(255,255,255,.15)',
      flexShrink: 0,
    },
    '.workoutplayer-exercise-title h1': {
      margin: 0,
      fontWeight: 600,
      fontSize: 20,
      opacity: 0.85,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '80%',
    },

    '.workoutplayer-meta-row': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: 8,
      marginTop: 4,
    },
    '.workoutplayer-chip': {
      background: 'rgba(255,255,255,.15)',
      color: '#fff',
    },
    '.workoutplayer-chip .MuiChip-icon': {
      color: '#fff',
    },

    '.workoutplayer-rest-strip': {
      marginBottom: 12,
      paddingBottom: 12,
      borderBottom: '1px solid rgba(255,255,255,.08)',
    },
    '.workoutplayer-rest-strip-row': {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
    },
    '.workoutplayer-rest-label': {
      fontSize: 13,
      opacity: 0.75,
      textTransform: 'uppercase',
      letterSpacing: 1,
    },
    '.workoutplayer-rest-countdown': {
      flex: 1,
      fontSize: 22,
      fontWeight: 700,
      fontVariantNumeric: 'tabular-nums',
    },
    '.workoutplayer-rest-skip-btn': {
      color: '#fff',
      borderColor: 'rgba(255,255,255,.4)',
      textTransform: 'none',
    },
    '.workoutplayer-rest-progress': {
      borderRadius: 4,
      backgroundColor: 'rgba(255,255,255,.15)',
    },
    '.workoutplayer-rest-progress .MuiLinearProgress-bar': {
      backgroundColor: '#4cafef',
    },

    '.workoutplayer-set-drawer-root .MuiDrawer-paper': {
      borderRadius: '16px 16px 0 0',
    },
    '.workoutplayer-set-drawer': {
      padding: '20px 20px 24px',
    },
    '.workoutplayer-set-drawer-actions': {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 8,
      marginTop: 16,
    },
    '.workoutplayer-set-field': {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    '.workoutplayer-set-stepper-row': {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    '.workoutplayer-set-stepper-btn': {
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: '50%',
      flexShrink: 0,
    },
    '.workoutplayer-set-presets': {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: 8,
    },
    '.workoutplayer-set-preset-chip': {
      minWidth: 44,
    },

    '.workoutplayer-finish-stats': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16,
      marginTop: 8,
    },
    '.workoutplayer-finish-stat': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '12px 8px',
      borderRadius: 12,
      background: 'rgba(0,0,0,.04)',
    },
    '.workoutplayer-finish-stat-value': {
      fontSize: 24,
      fontWeight: 700,
    },
    '.workoutplayer-finish-stat-label': {
      fontSize: 13,
      opacity: 0.65,
      marginTop: 4,
    },

    '.workoutplayer-extra-set-row': {
      display: 'flex',
      justifyContent: 'center',
      gap: 8,
      marginTop: 4,
    },
    '.workoutplayer-extra-set-btn': {
      color: 'rgba(255,255,255,.8)',
      textTransform: 'none',
    },

    '.workoutplayer-exercise-drawer': {
      padding: '16px 16px 24px',
      maxHeight: '75vh',
      overflowY: 'auto',
    },
    '.workoutplayer-exercise-drawer-item.Mui-selected': {
      backgroundColor: 'rgba(76,175,239,.12)',
    },

    '.workoutplayer-title-separator': {
      border: 0,
      borderTop: '1px solid rgba(255,255,255,.08)',
      margin: '12px 0',
    },

    '.workoutplayer-steps-wrap': {
      padding: '8px 16px',
    },

    '.cv-steps--on-dark .cv-steps__label': {
      color: 'rgba(255,255,255,.85)',
    },

    '.workoutplayer-buttons': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: 8,
      marginTop: 16,
    },

    '.workoutplayer-btn-next, .workoutplayer-btn-finish': {
      padding: '14px 0',
      fontWeight: 700,
      flex: 1,
      background: 'rgba(28,28,28,.75) !important',
    },

    '.workoutplayer-btn-skip': {
      padding: '14px 16px',
      fontWeight: 700,
      flexShrink: 0,
      color: '#fff',
      borderColor: 'rgba(255,255,255,.4)',
      background: 'rgba(28,28,28,.55) !important',
    },

    '.workoutplayer-loader': {
      width: '100%',
      margin: '1.5rem 0',
      textAlign: 'center',
    },
    '.workoutplayer-notfound, .workoutplayer-noexercises': {
      margin: 24,
      marginTop: '1.5rem',
    },
    '.workoutplayer-noexercises-card': { padding: 24, textAlign: 'center' },
    '.workoutplayer-noexercises-card svg': {
      fontSize: 64,
      color: '#ccc',
      marginBottom: 16,
    },
    '.workoutplayer-noexercises-card p': { color: '#999' },
  },
}))
